export const EXPERIMENT_NAME = 'in_editor_feedback';
export const FEEDBACK_TOGGLE_EVENT = 'elementor/open-feedback';
